import {EnvironmentType} from "./environment-type";

export const environment = {
  production: false,
  environmentType: EnvironmentType.uat,
  companyPortalUrl: 'https://uat-app.yoursafetycompliance.com',
  baseUrl: 'https://uat-api.yoursafetycompliance.com',
};
